<template>
  <b-container fluid>
    <iq-card>
      <template v-slot:headerTitle>
        <h4 class="card-title">{{ $t('social_service.follow_up') }} {{ $t('globalTrans.search') }}</h4>
      </template>
      <template v-slot:body>
        <b-row>
             <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                <b-form-group
                    class="row"
                    label-cols-sm="5"
                    :label="$t('social_service.follo_up_no')"
                    label-for="follow_up_no"
                    >
                   <b-form-input
                    id="follow_up_no"
                    v-model="search.follow_up_no"
                    placeholder=""
                   ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                <b-form-group
                    class="row"
                    label-cols-sm="5"
                    :label="$t('social_service.follo_date')"
                    label-for="follow_up_date"
                    >
                    <flat-pickr
                    class="form-control"
                    id="follow_up_date"
                    v-model="search.follow_up_date"
                    ></flat-pickr>
                </b-form-group>
            </b-col>
            <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group
                        class="row"
                        label-cols-sm="5"
                        :label="$t('globalTrans.mob_no')"
                        label-for="gender"
                        >
                        <b-form-input
                        v-model="search.phone_no"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group
                        class="row"
                        label-cols-sm="5"
                        :label="$t('hospital_information.form_no')"
                        label-for="gender"
                        >
                        <b-form-input
                        v-model="search.auto_id"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group
                        class="row"
                        label-cols-sm="5"
                        :label="$t('externalUser.brs_no')"
                        label-for="gender"
                        >
                        <b-form-input
                        v-model="search.brs_no"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group
                        class="row"
                        label-cols-sm="5"
                        :label="$t('externalUser.nid')"
                        label-for="gender"
                        >
                        <b-form-input
                        v-model="search.nid"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                  <b-form-group
                          class="row"
                          label-cols-sm="5"
                          :label="$t('social_service.patient')"
                          label-for="district_id"
                          >
                          <b-form-input
                            v-model="search.patient_name"
                            ></b-form-input>
                  </b-form-group>
                </b-col>
                <b-col lg="9" sm="9">
                  <ValidationProvider name="Hospital Name" vid="hospital_id">
                    <b-form-group
                      class="row"
                      label-cols-sm="12"
                      label-for="hospital_id"
                      slot-scope="{ valid, errors }"
                      >
                      <template v-slot:label>
                        {{ $t('hospital_configuration.hospital_name')}}
                      </template>
                      <v-select name="Bank"
                          v-model="search.hospital_id"
                          label="text"
                          :reduce="item => item.value"
                          :options= hospitalList
                          :placeholder="$t('globalTrans.select')"
                          :filter-by="myFilter"
                      />
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>
                <br>
            <b-col sm="12" md="4">
                <b-button type="button" variant="primary" @click="searchData">{{ $t('globalTrans.search')}}</b-button>
            </b-col>
             <!-- <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                <b-form-group
                    class="row"
                    label-cols-sm="5"
                    :label="$t('social_service.patient')"
                    label-for="avail_process"
                    >
                   <b-form-select plain v-model="search.patient_id" :options="patientList"
                              id="district_id">
                              <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                              </template>
                          </b-form-select>
                </b-form-group>
            </b-col> -->
        </b-row>
      </template>
    </iq-card>
    <b-row>
      <b-col md="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">{{ $t('social_service.follow_up') }}</h4>
          </template>
          <template v-slot:headerAction>
            <b-button variant="primary" @click="addForm">
              <i class="fas fa-plus"></i>{{  $t('globalTrans.add_new') }}
            </b-button>
          </template>
          <template v-slot:body>
            <b-overlay :show="loadingState">
              <b-row>
                <b-col md="12" class="table-responsive">
                  <b-table thead-class="bg-primary" bordered hover :items="listData" :fields="columns" aria-hidden="loading | listReload ? 'true' : null" :emptyText="$t('globalTrans.noDataFound')" show-empty>
                    <template v-slot:cell(index)="data">
                      {{ $n(data.index + pagination.slOffset) }}
                    </template>

                    <template v-slot:cell(follow_up_date)="data">
                        {{ data.item.follow_up_date | dateFormat }}
                    </template>

                    <template v-slot:cell(helping_date)="data">
                        {{ data.item.helping_date | dateFormat }}
                    </template>

                    <template v-slot:cell(docu)="data">
                      <div v-for="doc in data.item.followup_docs" :key="doc.id">
                        <!-- Download Link From Storage -->
                        <a :href="hospitalServiceBaseUrl + 'download-attachment?file=' + doc.attachment" target="_blank" v-if="doc.id > 0">
                          {{ doc.attachment.split('/').pop() }}
                          <i class="ri-download-cloud-line" ></i>
                        </a>
                      </div>
                    </template>

                    <template v-slot:cell(status)="data">
                      <span class="badge badge-danger" v-if="data.item.status == 2">{{$t('globalTrans.inactive')}}</span>
                      <span class="badge badge-success" v-else>{{$t('globalTrans.active')}}</span>
                    </template>

                    <template v-slot:cell(action)="data">
                      <!-- <b-button variant=" iq-bg-success mr-1 mb-1" size="sm">
                        <router-link :to="{ path: '/hospital-disability-service/social-service/followup-info-add', query: { id: data.item.id }}" class="iq-bg-success mr-1 mb-1" size="sm">
                          <i class="ri-ball-pen-fill m-0"></i>
                        </router-link>
                      </b-button>

                     <b-button v-b-modal.modal-5 variant=" iq-bg-success mr-1 mb-1" size="sm" @click="view(data.item)"><i class="ri-eye-fill m-0"></i></b-button>

                      <b-button :variant="data.item.status === 2 ? ' iq-bg-danger' : ' iq-bg-success'" size="sm" @click="remove(data.item)">
                        <i class="fas" :class="data.item.status === 2 ? 'fa-toggle-off' : 'fa-toggle-on'"></i>
                      </b-button> -->
                      <span class="d-flex">
                        <router-link class="btn_table_action btn_blue" :to="{ path: '/hospital-disability-service/social-service/followup-info-add', query: { id: data.item.id }}">
                          <i class="ri-ball-pen-fill m-0"></i>
                        </router-link>
                        <a href="javascript:" class="btn_table_action btn_green" v-b-modal.modal-5 @click="view(data.item)"><i class="ri-eye-fill m-0"></i></a>
                        <a href="javascript:" class="btn_table_action" :class="data.item.status === 2 ? 'btn_rad' : 'btn_green'" @click="remove(data.item)">
                          <i class="fas" :class="data.item.status === 2 ? 'fa-toggle-off' : 'fa-toggle-on'"></i>
                        </a>
                      </span>
                    </template>
                  </b-table>
                  <b-pagination
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total-rows="pagination.totalRows"
                    @input="searchData"
                    />
                </b-col>
              </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>

    <b-modal id="modal-5" size="xl" :title="$t('social_service.follow_up')"  :ok-title="$t('globalTrans.close')" ok-only ok-variant="danger">
      <Details :id="editItemId" :hospitalServiceBaseUrl="hospitalServiceBaseUrl"/>
    </b-modal>

  </b-container>
</template>
<script>
import Details from './Details'
// import FormV from './Form'
import RestApi, { hospitalServiceBaseUrl } from '@/config/api_config'
import { followUpListApi, followUpToggleStatusApi, assignUserHospitalApi } from '../../../api/routes'
import RouteBasedList from '@/mixins/route-base-list'

export default {
    mixins: [RouteBasedList],
    components: {
        Details
    },
    data () {
      return {
        search: {
          follow_up_no: '',
          follow_up_date: '',
          hospital_id: '',
          phone_no: '',
          auto_id: '',
          brs_no: '',
          nid: '',
          patient_name: ''
        },
        editItemId: '',
        item: '',
        hospitalIds: [],
        rows: [],
        hospitalList: [],
        hospitalServiceBaseUrl: hospitalServiceBaseUrl
      }
    },
    computed: {
        columns () {
            const labels = [
                { label: this.$t('globalTrans.sl_no'), class: 'text-left' },
                { label: this.$t('social_service.follo_up_no'), class: 'text-left' },
                { label: this.$t('social_service.follow_up_date'), class: 'text-left' },
                { label: this.$t('social_service.patient_nam'), class: 'text-left' },
                { label: this.$t('social_service.docu'), class: 'text-left' },
                { label: this.$t('social_service.helping_date'), class: 'text-left' },
                { label: this.$t('globalTrans.status'), class: 'text-center' },
                { label: this.$t('globalTrans.action'), class: 'text-center' }
            ]

            let keys = []

            if (this.$i18n.locale === 'bn') {
                keys = [
                  { key: 'index' },
                  { key: 'follow_up_no' },
                  { key: 'follow_up_date' },
                  { key: 'patient_reg_mains.patient_name_bn' },
                  { key: 'docu' },
                  { key: 'helping_date' },
                  { key: 'status' },
                  { key: 'action' }
                ]
            } else {
                keys = [
                  { key: 'index' },
                  { key: 'follow_up_no' },
                  { key: 'follow_up_date' },
                  { key: 'patient_reg_mains.patient_name' },
                  { key: 'docu' },
                  { key: 'helping_date' },
                  { key: 'status' },
                  { key: 'action' }
                ]
            }

            return labels.map((item, index) => {
                return Object.assign(item, keys[index])
            })
        }
    },
    watch: {
    },
    created () {
        this.hospitalList = this.getHospitalListAll()
        this.loadData()
        var officeId = this.$store.state.Auth.authUser.office_id
        if (officeId > 1) {
            this.userId = this.$store.state.Auth.authUser.user_id
            if (this.userId > 1) {
                this.getUserWiseHospital(this.userId)
            }
        } else {
            this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1).map((obj, key) => {
                this.hospitalIds.push(obj.value)
            })
            this.loadData()
            // this.hospitalList = this.getHospitalList()
        }
        if (this.$store.state.Auth.activeRoleId !== 1) {
          if (this.$store.state.Auth.authUser.is_org_admin !== 1) {
            this.getUserWiseHospital(this.userId)
          }
        }
    },
    methods: {
        myFilter: (option, text, search) => {
            const temp = search.toLowerCase()
            return option.text_en.toLowerCase().indexOf(temp) > -1 ||
            option.text_bn.toLowerCase().indexOf(temp) > -1
        },
        async getUserWiseHospital (userId) {
          const params = Object.assign({ user_id: userId })
          const result = await RestApi.getData(hospitalServiceBaseUrl, assignUserHospitalApi, params)
          if (result.success) {
                  this.hospitalIds = result.data
          } else {
                this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1).map((obj, key) => {
                    this.hospitalIds.push(obj.value)
                })
          }
          this.loadData()
          this.hospitalList = this.getHospitalListAll()
          if (this.hospitalList.length) {
            this.search.hospital_id = this.hospitalList[0].value
          }
        },
        getHospitalListAll: function () {
          let hospitalList = this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1)
          if (this.hospitalIds.length > 0) {
            hospitalList = hospitalList.filter((p) => this.hospitalIds.includes(p.value))
          }
          return hospitalList
        },
        searchData () {
          this.loadData()
        },
        view (item) {
          this.editItemId = item.id
        },
        edit (item) {
          this.editItemId = item.id
          this.item = item
          this.$router.push({ path: '/hospital-disability-service/social-service/followup-info-add', query: { item: item } })
        },
        remove (item) {
          this.changeStatus(hospitalServiceBaseUrl, followUpToggleStatusApi, item)
        },
        addForm () {
          this.$router.push({ path: '/hospital-disability-service/social-service/followup-info-add' })
        },
        // --- Load ---
        loadData () {
          const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })
          this.$store.dispatch('mutateCommonProperties', { loading: true, listReload: false })
          RestApi.getData(hospitalServiceBaseUrl, followUpListApi, params).then(response => {
              if (response.success) {
                  this.$store.dispatch('setList', (response.data.data))
                  this.paginationData(response.data)
              }
              this.$store.dispatch('mutateCommonProperties', { loading: false, listReload: false })
          })
        }
    }
}
</script>
